import { useState } from "react";
import { rapidozi_contact_utils } from "../utils/frfr-rapidozi-contact-utils";

// Image slider sub-component
const _YmImgSlider = ({ images }) => {
  const [idx, setIdx] = useState(0);

  // Deduplicate and filter empty
  const imgs = images.filter((src, i, arr) => src && arr.indexOf(src) === i);

  if (imgs.length === 0) {
    return (
      <div className="ym-img-slider ym-img-slider--placeholder">
        <i className="fa fa-picture-o" aria-hidden="true"></i>
      </div>
    );
  }

  if (imgs.length === 1) {
    return (
      <div className="ym-img-slider ym-img-slider--single">
        <div
          className="ym-img-slider__img"
          style={{ backgroundImage: 'url("' + imgs[0] + '")' }}
        ></div>
      </div>
    );
  }

  const prev = () => setIdx((i) => (i - 1 + imgs.length) % imgs.length);
  const next = () => setIdx((i) => (i + 1) % imgs.length);

  return (
    <div className="ym-img-slider">
      <div className="ym-img-slider__track-wrap">
        <div
          className="ym-img-slider__track"
          style={{ transform: 'translateX(-' + (idx * 100) + '%)' }}
        >
          {imgs.map((src, i) => (
            <div
              key={i}
              className="ym-img-slider__img"
              style={{ backgroundImage: 'url("' + src + '")' }}
            ></div>
          ))}
        </div>
      </div>
      <button
        className="ym-img-slider__arrow ym-img-slider__arrow--prev"
        onClick={prev}
        aria-label="Prethodna slika"
        type="button"
      >
        <i className="fa fa-chevron-left" aria-hidden="true"></i>
      </button>
      <button
        className="ym-img-slider__arrow ym-img-slider__arrow--next"
        onClick={next}
        aria-label="Sledeća slika"
        type="button"
      >
        <i className="fa fa-chevron-right" aria-hidden="true"></i>
      </button>
      <div className="ym-img-slider__dots" aria-hidden="true">
        {imgs.map((_, i) => (
          <button
            key={i}
            type="button"
            className={'ym-img-slider__dot' + (i === idx ? ' ym-img-slider__dot--active' : '')}
            onClick={() => setIdx(i)}
          ></button>
        ))}
      </div>
      <div className="ym-img-slider__counter" aria-live="polite">
        {idx + 1} / {imgs.length}
      </div>
    </div>
  );
};

// Main popup card component
const YourmapMapMarkerPopup = ({ markerKey, item, onNavigate }) => {
  const _hasText = (v) => typeof v === 'string' && v.trim().length > 0;
  const _phone = item.telefon || item.mobilni || item.telefon2 || item.mobilni2 || null;
  const showMoreButton = item.smestaj_tab !== 'NONE' && item?.vr_tablename !== 'ym_table_ignored';

  // Build image array: _slide_img_src_arr already contains main + gallery
  const images = Array.isArray(item._slide_img_src_arr)
    ? item._slide_img_src_arr
    : (item._main_img_url ? [item._main_img_url] : []);

  const hasContactRow = _hasText(_phone) || _hasText(item.smestaj_adresa) || _hasText(item.email) || _hasText(item.email2) || _hasText(item.websajt);

  return (
    <div className="yourmap__map__marker_popup-content" data-marker-key={markerKey}>
      <div className="yourmap__map__marker_popup-content__scroll-body">
        <_YmImgSlider images={images} />
        <div className="yourmap__map__marker_popup-content__info">
          <h2 className="yourmap__map__marker_popup-content__title">{item.smestaj_naslov}</h2>
          {_hasText(item.smestaj_podnaslov) && (
            <p className="yourmap__map__marker_popup-content__subtitle">{item.smestaj_podnaslov}</p>
          )}
          {hasContactRow && (
            <div className="yourmap__map__marker_popup-content__meta">
              {_hasText(_phone) && (
                <a
                  className="yourmap__map__marker_popup-content__meta-row"
                  href={'tel:' + rapidozi_contact_utils.fix_contact_phone_number(_phone)}
                >
                  <i className="fa fa-phone" aria-hidden="true"></i>
                  <span>{_phone}</span>
                </a>
              )}
              {_hasText(item.smestaj_adresa) && (
                <div className="yourmap__map__marker_popup-content__meta-row">
                  <i className="fa fa-map-marker" aria-hidden="true"></i>
                  <span>{item.smestaj_adresa}</span>
                </div>
              )}
              {_hasText(item.email) && (
                <a
                  className="yourmap__map__marker_popup-content__meta-row"
                  href={'mailto:' + item.email}
                >
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                  <span>{item.email}</span>
                </a>
              )}
              {_hasText(item.email2) && (
                <a
                  className="yourmap__map__marker_popup-content__meta-row"
                  href={'mailto:' + item.email2}
                >
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                  <span>{item.email2}</span>
                </a>
              )}
              {_hasText(item.websajt) && (
                <a
                  className="yourmap__map__marker_popup-content__meta-row"
                  href={rapidozi_contact_utils.fix_contact_website_url(item.websajt)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-globe" aria-hidden="true"></i>
                  <span>{item.websajt}</span>
                </a>
              )}
            </div>
          )}
          {_hasText(item.smestaj_opis) && (
            <>
              <div className="yourmap__map__marker_popup-content__divider" aria-hidden="true"></div>
              <p className="info-description-long">{item.smestaj_opis}</p>
            </>
          )}
        </div>
      </div>
      <div className="yourmap__map__marker_popup-content__footer">
        {showMoreButton && (
          <button
            type="button"
            className="ym-popup-btn-primary"
            onClick={onNavigate}
          >
            Više
          </button>
        )}
      </div>
    </div>
  );
};

export default YourmapMapMarkerPopup;
